import { render, staticRenderFns } from "./RoutingAreaList.vue?vue&type=template&id=d132484a&"
import script from "./RoutingAreaList.vue?vue&type=script&lang=js&"
export * from "./RoutingAreaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports